// Get all nested accordions and loop through them
const accordionsNested = document.querySelectorAll('.accordion__group-nested');
accordionsNested.forEach(accordion => {
  // Get all accordion items within the accordion and loop through them
  let items = accordion.querySelectorAll('.accordion__item-nested');
  items.forEach(item => {
    // Lets get the button and the content elements
    let button = item.querySelector('button');
    let content = item.querySelector('.accordion__item__content-nested');
    // Add a listener to the click event for the button
    button.addEventListener('click', event => {
      // Get the current expanded status of the accordion item
      let expanded = button.getAttribute('aria-expanded') === 'true' || false;
      // Fire off a function to hide all currently open accordion items
      hideExpandedAccordion(accordion);
      // Set this accordion item's button to the applicable expanded status
      button.setAttribute('aria-expanded', !expanded);
      // Either hide/show the content depending on the expanded status
      content.hidden = expanded;
      event.preventDefault();
    });
  });
});

// Get all accordions and loop through them
const accordions = document.querySelectorAll('.accordion__group');
accordions.forEach(accordion => {
  // Get all accordion items within the accordion and loop through them
  let items = accordion.querySelectorAll('.accordion__item');
  items.forEach(item => {
    // Lets get the button and the content elements
    let button = item.querySelector('button');
    let content = item.querySelector('.accordion__item__content');
    // Add a listener to the click event for the button
    button.addEventListener('click', event => {
      // Get the current expanded status of the accordion item
      let expanded = button.getAttribute('aria-expanded') === 'true' || false;
      // Fire off a function to hide all currently open accordion items
      hideExpandedAccordion(accordion);
      // Set this accordion item's button to the applicable expanded status
      button.setAttribute('aria-expanded', !expanded);
      // Either hide/show the content depending on the expanded status
      content.hidden = expanded;

      var headerOffset = document.querySelector('header.header').offsetHeight + 30;
      var scrollLoc = getPageOffset(button) - headerOffset;

      window.scrollTo({
        top: scrollLoc,
        left: 0,
        behavior: "smooth",
      });

      //console.log('scrolled');
      event.preventDefault();
    });
  });
});
function getPageOffset(elem) {
  let topOffset = elem.getBoundingClientRect().top;

  while (elem != document.documentElement) {
    elem = elem.parentElement;
    topOffset += elem.scrollTop;
  }
  return topOffset;
}
function hideExpandedAccordion(accordion) {
  // Get all buttons that are set to expanded
  let accordionButtons = accordion.querySelectorAll('button[aria-expanded=true]');
  // If we have some then lets loop through and close them
  if (accordionButtons) {
    accordionButtons.forEach(accordionButton => {
      // Need to get the content element for this button
      let content = accordion.querySelector('#' + accordionButton.getAttribute('aria-controls'));
      // Set the button to be no longer expanded
      accordionButton.setAttribute('aria-expanded', 'false');
      // Hide the content
      content.hidden = true;
    });
  }
}
